export enum TerminalPromptType {
  BASH,
  JS,
}
